export * from './documents/documents.component';
export * from './documents.module';



// WEBPACK FOOTER //
// ./src/app/documents/index.ts